export default __webpack_public_path__ + "static/media/White0001.0a931b0c.png";